export default {
    ossConfig: {
        development: {
            // authority:'http://localhost:8080/user/getTempToken?userName=hedymao',
             authority:'http://localhost:8080/user/getTempToken?userName=aimeexia',
            //authority: 'http://10.166.210.57:8082/user/getTempToken?userName=aimeexia',//uat
            // authority: 'http://10.166.210.57:8088/user/getTempToken?userName=jfan4',//sit
            // authority:'http://localhost:8080/user/getTempToken?userName=simchahchu', hk
            client_id: 'kdi_kccp_uat',
            redirect_uri: 'https://kcc.uat.cn.kworld.kpmg.com/user/ad/login'
        },
        uat: {
            cn: {
                authority: 'https://cnshaapt100.cn.kworld.kpmg.com:7001/connect/authorize/callback',
                client_id: 'kdi_kcc_uat',
                redirect_uri: 'https://kcc.uat.cn.kworld.kpmg.com/user/ad/login',
                nonce: 'n-0S6_WzA2Mj'
            },
            overseas: {
                authority: 'https://login.microsoftonline.com/deff24bb-2089-4400-8c8e-f71e680378b2/oauth2/v2.0/authorize',
                client_id: '05202259-ad7b-443d-8d53-6c51ca6c426d',
                redirect_uri: 'https%3A%2F%2Fkcc.uat.cn.kworld.kpmg.com%2Fuser%2Fad%2Flogin',
                nonce: '619114143'
            }
        },
        sit: {
            cn: {
                authority: 'https://cnbjsapt06.cn.kworld.kpmg.com:7003/connect/authorize/callback',
                client_id: 'kdi_sso_kcc_sit',
                redirect_uri: 'https%3A%2F%2Fkcc.uat.cn.kworld.kpmg.com:8887%2Fuser%2Fad%2Flogin',
                nonce: '619114143'
            },
            overseas: {
                authority: 'https://cnbjsapt06.cn.kworld.kpmg.com:7003/connect/authorize/callback',
                client_id: 'kdi_sso_kcc_sit',
                redirect_uri: 'https%3A%2F%2Fkcc.uat.cn.kworld.kpmg.com:8887%2Fuser%2Fad%2Flogin',
                nonce: '619114143'
            }
        },
        prod: {
            cn: {
                authority: 'https://sso.cn.kworld.kpmg.com:7001/connect/authorize/callback',
                client_id: 'kdi_kcc_prod',
                redirect_uri: 'https://kcc.cn.kworld.kpmg.com/user/ad/login',
                nonce: 'n-0S6_WzA2Mj'
            },
            overseas: {
                authority: 'https://login.microsoftonline.com/deff24bb-2089-4400-8c8e-f71e680378b2/oauth2/v2.0/authorize',
                client_id: '36081db2-bfe4-457a-9843-0b32b4f62ae3',
                redirect_uri: 'https%3A%2F%2Fkcc.cn.kworld.kpmg.com%2Fuser%2Fad%2Flogin',
                nonce: '619114143'
            }
        }
    },
    commonOssConfig: {
        response_type: 'id_token',
        scope: 'openidprofile',
        post_logout_redirect_uri: ''
    },

    download: {
        size: 1024 * 1024 * 1024 * 1
    },
    helpURL: {
        howToUploadPBCFile: 'https://home.kpmg/cn/zh/home/insights/2020/09/kcc-user-guide-upload-pbc-documents.html',
        howToConfigureKCCSite: 'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_6xc0v6dk',
        howToDownloadPBCFiles: 'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_hewfrpun',
        Contact: 'mailto:cnfmkpmgclicbt@kpmg.com',
        faqKp: {
            zh: 'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/SitePages/KCCQAs-CN.aspx',
            en: 'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/SitePages/KCCQAs-EN.aspx'
        },
        portal: 'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/SitePages/KCC.aspx'
    }
}
